(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pavora-header"]) return;
  try {
    
  if (!window.pavoraCartRedirectInitialized) {
    window.pavoraCartRedirectInitialized = true;
    document.addEventListener('theme:cart:popdown', function (event) {
      var origin = event.target;
      if (!(origin instanceof Element) || !origin.hasAttribute('data-pv-cart-redirect')) return;
      window.location.assign(origin.getAttribute('data-pv-cart-redirect'));
    });
  }

  } catch(e) { console.error(e); }
})();
})();
